import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrainlineLinkComponent } from './components/trainline-link';
import { DebugHelperDirectiveModule } from './directives/debug-helper';
import { AwardLabelComponent } from './components/award-label';
import { OfferBannerComponent } from './components/offer-banner';

@NgModule({
  imports: [CommonModule, TrainlineLinkComponent, DebugHelperDirectiveModule, AwardLabelComponent, OfferBannerComponent],
  exports: [TrainlineLinkComponent, DebugHelperDirectiveModule, AwardLabelComponent, OfferBannerComponent],
})
export class ClientsiteSharedUiModule {}
